const translation = {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.tours": "Tour Packages",
  "nav.gallery": "Gallery",
  "nav.testimonials": "Testimonials",
  "nav.contact": "Contact",
  "nav.bookNow": "Book Now",
  "nav.busTickets": "Bus Tickets",
  "nav.certifications": "Certifications",

  // Hero
  "hero.slide1.headline": "Explore the World",
  "hero.slide1.sub": "with Confidence",
  "hero.slide1.tagline": "Malaysia's trusted travel partner since 2008. Crafting extraordinary journeys for over 20,000 happy travellers.",
  "hero.slide2.headline": "Discover Asia",
  "hero.slide2.sub": "Beyond Imagination",
  "hero.slide2.tagline": "From the cherry blossoms of Japan to the temples of Bali — Asia awaits your arrival.",
  "hero.slide3.headline": "Dream Destinations",
  "hero.slide3.sub": "Made Affordable",
  "hero.slide3.tagline": "From Europe to the Maldives, we make your dream holidays a beautiful reality.",
  "hero.badge": "Arus Travel & Tours Sdn Bhd",
  "hero.cta.explore": "Explore Packages",
  "hero.cta.bus": "Book Bus Ticket",
  "hero.cta.contact": "Contact Us",

  // Featured Tours
  "featured.badge": "Handpicked For You",
  "featured.title": "Featured Tour Packages",
  "featured.subtitle": "Explore our most popular, carefully curated journeys — each designed to create memories that last a lifetime.",
  "featured.viewAll": "View All Packages",
  "featured.viewDetails": "View Details",
  "featured.perPax": "/ pax",
  "featured.reviews": "reviews",

  // Popular Destinations
  "destinations.badge": "Where To Go",
  "destinations.title": "Popular Destinations",
  "destinations.subtitle": "From tropical paradises to cultural wonders — discover the world's most breathtaking destinations.",
  "destinations.explore": "Explore Now",
  "destinations.packages": "packages",

  // Bus Ticketing
  "bus.badge": "Intercity Express Bus",
  "bus.title": "Book Your Bus Ticket",
  "bus.titleHighlight": "Fast & Easy",
  "bus.description": "Travelling within Malaysia? Book your intercity express bus ticket online through our trusted partner Easybook — covering major routes across the Peninsula with licensed operators.",
  "bus.bookNow": "Book Bus Ticket Now",
  "bus.poweredBy": "Bus ticketing powered by our partner platform",
  "bus.f1.label": "Intercity Routes",
  "bus.f1.desc": "KL, Penang, JB & more",
  "bus.f2.label": "Safe & Reliable",
  "bus.f2.desc": "Licensed operators only",
  "bus.f3.label": "Instant Booking",
  "bus.f3.desc": "E-ticket in seconds",
  "bus.f4.label": "Best Fares",
  "bus.f4.desc": "No hidden charges",

  // Why Choose Us
  "why.badge": "Our Promise",
  "why.title": "Why Choose Arus Travel?",
  "why.subtitle": "We go beyond booking flights and hotels — we craft experiences that you will treasure forever.",
  "why.r1.title": "Licensed & Trusted",
  "why.r1.desc": "Fully licensed by the Ministry of Tourism Malaysia (MOT) and a proud MATTA and IATA member. Your safety and satisfaction are our top priority.",
  "why.r2.title": "24/7 Support",
  "why.r2.desc": "Our dedicated travel consultants are available around the clock to assist you before, during, and after your trip.",
  "why.r3.title": "Best Price Guarantee",
  "why.r3.desc": "We negotiate the best rates with airlines and hotels so you get the most value for your money — no hidden fees, ever.",
  "why.r4.title": "Tailored Itineraries",
  "why.r4.desc": "Every journey we create is customised to your preferences, travel style, and budget — from solo trips to large group tours.",
  "why.r5.title": "Expert Local Guides",
  "why.r5.desc": "Our network of experienced, multilingual local guides enriches your travel experience with authentic cultural insights.",
  "why.r6.title": "20,000+ Happy Travellers",
  "why.r6.desc": "Over 17 years of experience and thousands of satisfied customers — we are proudly rated 4.9/5 stars across all platforms.",

  // Stats
  "stats.badge": "Our Track Record",
  "stats.title": "Two Decades of Travel Excellence",
  "stats.l1": "Years of Excellence",
  "stats.l2": "Destinations Worldwide",
  "stats.l3": "Happy Travellers",
  "stats.l4": "Customer Rating",

  // Testimonials
  "testimonials.badge": "What Our Clients Say",
  "testimonials.title": "Traveller Stories",
  "testimonials.subtitle": "Hear from thousands of happy travellers who trusted Arus Travel to create their perfect holiday.",
  "testimonials.readAll": "Read All Reviews",

  // CTA
  "cta.badge": "Start Your Adventure",
  "cta.title": "Your Dream Holiday",
  "cta.titleLine2": "Starts Here",
  "cta.subtitle": "Talk to our travel consultants today and let us craft the perfect journey tailored just for you. No obligation, no hassle — just great travel advice.",
  "cta.browse": "Browse All Tours",
  "cta.consultation": "Get Free Consultation",

  // Footer
  "footer.tagline": "Your trusted travel partner since 2008. We create unforgettable journeys tailored to your dreams, delivering exceptional service at every step.",
  "footer.quickLinks": "Quick Links",
  "footer.destinations": "Destinations",
  "footer.contactUs": "Contact Us",
  "footer.hours": "Mon – Sat: 9:00am – 6:00pm",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms & Conditions",
  "footer.d1": "Southeast Asia Tours",
  "footer.d2": "East Asia Tours",
  "footer.d3": "Europe Tours",
  "footer.d4": "Middle East Tours",
  "footer.d5": "Indian Ocean Tours",
  "footer.d6": "Honeymoon Packages",
};

export default translation;
